import { TableColumnType } from 'src/types/table';

export const allColumns: TableColumnType[] = [
    {
        key: 'ID',
        label: 'orderId',
        type: 'number',
        defaultShow: true,
        disableFilter: true,
        disableSort: true,
    },
    {
        key: 'ESHOP_ORDER_ID',
        label: 'eshopId',
        defaultShow: true,
        disableFilter: true,
        disableSort: true,
    },
    {
        key: 'RECIPIENT_NAME',
        label: 'recipientName',
        defaultShow: true,
        disableFilter: true,
        disableSort: true,
    },
    {
        key: 'TIMESTAMP',
        label: 'date',
        type: 'dateTime',
        defaultShow: true,
        disableFilter: true,
        disableSort: true,
    },
    {
        key: 'reason',
        label: 'overviewReason',
        defaultShow: true,
        disableFilter: true,
        disableSort: true,
        customRender: true,
    },
    {
        key: 'waitingDays',
        label: 'waitingDays',
        defaultShow: true,
        disableFilter: true,
        disableSort: true,
        type: 'number',
    },
];
